<template>
    <!-- 添加学习经历的对话框 -->
    <div class="studyModal">
      <a-modal
       :title="biaoji ? '修改学习经历' : '新增学习经历'"
       :visible="showVisible"
       okText="下一步"
       :footer="null"
       @cancel="cancel"
       :dialogStyle="dialogStyle"
      >



   
          <a-form-model ref="XXRef" :rules="XXRule" :model="formStudy" :label-col="labelCol" :wrapper-col="wrapperCol">

            <a-row>
             <a-col :span="12" :offset="1">
              <a-form-model-item label="入学时间" prop="a0801">
              <a-date-picker :disabled-date="disabledStartDate" :inputReadOnly="true" placeholder="入学时间" show-tiem type="date"  v-model="formStudy.a0801" style="width: 180px"></a-date-picker>
              </a-form-model-item>
             </a-col>

              <a-col :span="11">
                <a-form-model-item label="毕业时间" prop="a0802">
                <a-date-picker :disabled-date="disabledEndDate" :inputReadOnly="true" placeholder="毕业时间" show-tiem type="date" v-model="formStudy.a0802" style="width: 180px"></a-date-picker>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
             <a-col :span="12" :offset="1">
              <a-form-model-item label="毕业院校" prop="a0805">
              <a-input :maxLength="20" v-model="formStudy.a0805" style="width: 180px"></a-input>
              </a-form-model-item>
             </a-col>

              <a-col :span="11">
                <a-form-model-item label="所在院系" prop="a0806">
                <a-input :maxLength="20" v-model="formStudy.a0806" style="width: 180px"></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
             <a-col :span="12" :offset="1">
              <a-form-model-item label="所学专业" prop="a0807">
              <a-input :maxLength="20" v-model="formStudy.a0807" style="width: 180px"></a-input>
              </a-form-model-item>
             </a-col>

              <a-col :span="11">
                <a-form-model-item label="学历" prop="a0803">
                <a-select allowClear v-model="formStudy.a0803" style="width: 180px">
                  <a-select-option v-for="(item,i) in educationList" :key="i" :value="item.DMCOD">{{item.DMCPT}}</a-select-option>
                </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
             <a-col :span="12" :offset="1">
              <a-form-model-item label="学位" prop="a0804">
               <a-select allowClear v-model="formStudy.a0804" style="width: 180px">
                  <a-select-option v-for="(item,i) in academic" :key="i" :value="item.DMCOD">{{item.DMCPT}}</a-select-option>
                </a-select>
              </a-form-model-item>
             </a-col>

              <a-col :span="11">
                <a-form-model-item label="教育类型" prop="a0813">
                 <a-select allowClear v-model="formStudy.a0813" style="width: 180px">
                  <a-select-option v-for="(item,i) in Education" :key="i" :value="item.DMCOD">{{item.DMCPT}}</a-select-option>
                </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
          
            <a-row>
              <a-col :span="15">
                <a-form-model-item label="学制" prop="a0814">
                <a-select allowClear v-model="formStudy.a0814" style="width: 180px">
                  <a-select-option v-for="(item,i) in system" :key="i" :value="item.DMCOD">{{item.DMCPT}}</a-select-option>
                </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
            

          </a-form-model>


        <div class="dialogFooter">
        <!-- 保存 -->
        <button class="btnStyle1" @click="addLearningExperience" v-show="!biaoji">保存</button>
         <!-- 修改 -->
        <button class="btnStyle1" @click="updateLearningExperience" v-show="biaoji">保存</button>
        <!-- 取消 -->
        <button class="btnStyle1" @click="cancel">取消</button>
      </div>

      </a-modal>
    </div>
</template>

<script>
import moment from 'moment'
import { type } from 'os';
export default {
  props:{
    studyVisible:{
      type:Boolean,
      require:true
    },
    studyInfo:{
      type:Object,
      require:true
    }
  },
  data(){
    return{
      labelCol: { span: 9 },
      wrapperCol: { span: 10 },

      showVisible:false,

      //学习经历表单数据
      formStudy:{},

      //下拉框数据
      //  学历
      educationList:[],
      //学位
      academic:[],
      //教育类型
      Education:[],
      //学制
      system:[],


      biaoji:null,

      dialogStyle: {
        right:"100px"
      },


      //校验规则
      XXRule:{
        a0801: [
          { required: true, message: '请输入入学时间', trigger: 'change' },
        ],
        a0802: [
          { required: true, message: '请输入毕业时间', trigger: 'change' },
        ],
        a0805: [
          { required: true, message: '请输入毕业院校', trigger: 'blur' },
        ],
        a0806: [
          { required: true, message: '请输入所在院系', trigger: 'blur' },
        ],
        a0807: [
          { required: true, message: '请输入所学专业', trigger: 'blur' },
        ],
        a0803: [
          { required: true, message: '请输入学历', trigger: 'blur' },
        ],
        a0804: [
        ],
        a0813: [
        ],
        a0814: [
        ],
      }


      
    }
  },

  mounted(){
    this.showVisible=this.studyVisible
  },

  watch:{
    studyVisible(){
      this.getxl()
    this.getxw()
    this.getjylx()
    this.getxz()
      this.showVisible=this.studyVisible
    },
    studyInfo(){
      this.formStudy=this.studyInfo
      this.biaoji=this.studyInfo.biaoji
    }
  },

  methods:{
   
    disabledStartDate(startValue) {
      const endValue = this.formStudy.a0802;
      if (!startValue || !endValue) {
        return false;
      }
      return startValue.valueOf() > endValue.valueOf();
    },
    disabledEndDate(endValue) {
      const startValue = this.formStudy.a0801;
      if (!endValue || !startValue) {
        return false;
      }
      return startValue.valueOf() >= endValue.valueOf();
    },
    //新增学习经历
    addLearningExperience(){
      if(typeof(this.formStudy.a0814) !== "undefined"){
        if(!typeof(this.formStudy.a0814*0)!=='number'){
          this.system.map(i=>{
          if(i.DMCPT==this.formStudy.a0814){
              this.formStudy.a0814= i.DMCOD
          }
        })
        }
        if(this.formStudy.a0801 && this.formStudy.a0802){
          let data = (this.formStudy.a0802).unix() - (this.formStudy.a0801).unix()
          let years = Math.floor(data/(24*3600*365))
          if(years !== Number(this.formStudy.a0814)){
            this.$message.warning('您填写的学制与入学起始时间不一致，请重新填写')
            return
          }
        }
      }

      var that=this
       this.$refs.XXRef.validate(valid => {
        if(!valid) return this.$message.warning('请完成表单内容')
       //此处修改下拉框数据 为真实值
      if(!typeof(this.formStudy.a0803*0)!=='number'){
        this.educationList.map(i=>{
        if(i.DMCPT==this.formStudy.a0803){
            this.formStudy.a0803= i.DMCOD
        }
      })
      }else{
        // this.nations.a0104*0+1
      }

      if(!typeof(this.formStudy.a0804*0)!=='number'){
        this.academic.map(i=>{
        if(i.DMCPT==this.formStudy.a0804){
            this.formStudy.a0804= i.DMCOD
        }
      })
      }else{
        // this.nations.a0104*0+1
      }

      if(!typeof(this.formStudy.a0813*0)!=='number'){
        this.Education.map(i=>{
        if(i.DMCPT==this.formStudy.a0813){
            this.formStudy.a0813= i.DMCOD
        }
      })
      }else{
        // this.nations.a0104*0+1
      }

      if(!typeof(this.formStudy.a0814*0)!=='number'){
        this.system.map(i=>{
        if(i.DMCPT==this.formStudy.a0814){
            this.formStudy.a0814= i.DMCOD
        }
      })
      }else{
        // this.nations.a0104*0+1
      }
      //此处格式化时间
      if(typeof(this.formStudy.a0801)=='string'){
        if(getTargetTime(this.formStudy.a0801)>new Date().getTime()) return this.$message.warning('入学时间不能晚于当前时间');
      }else{
       if((this.formStudy.a0801).unix()*1000>new Date().getTime()) return this.$message.warning('入学时间不能晚于当前时间');
      }

       if(typeof(this.formStudy.a0801)=='string'&&(typeof(this.formStudy.a0802)=='string')){
         console.log(1);
         if(getTargetTime(this.formStudy.a0801)>getTargetTime(this.formStudy.a0802)) return this.$message.warning('入学时间不能晚于毕业时间');
       }else if(typeof(this.formStudy.a0801)=='string'){
         console.log(2);
         if(getTargetTime(this.formStudy.a0801)>(this.formStudy.a0802).unix()*1000) return this.$message.warning('入学时间不能晚于毕业时间');
       }else if(typeof(this.formStudy.a0802)=='string'){
         console.log(3);
         if((this.formStudy.a0801).unix()*1000>getTargetTime(this.formStudy.a0802)) return this.$message.warning('入学时间不能晚于毕业时间');
       }else{
         console.log(4);
         if((this.formStudy.a0801).unix()>(this.formStudy.a0802).unix()) return this.$message.warning('入学时间不能晚于毕业时间');
       }
      
      this.formStudy.a0801=moment(this.formStudy.a0801).format('YYYY-MM-DD');
      this.formStudy.a0802=moment(this.formStudy.a0802).format('YYYY-MM-DD');

      this.formStudy.a00=sessionStorage.getItem('aabb')
      console.log(this.formStudy);
      this.post({
        url:'addLearningExperience',
        data:this.formStudy
      },(res)=>{
        if(res.code==200){
          console.log(res);
          this.$message.success('新增学习经历成功')
          this.cancel()
          this.$emit('updt')
        }
      })
       })
    },
    //修改学习经历
    updateLearningExperience(){
      if(typeof(this.formStudy.a0814) !== "undefined"){
        if(!typeof(this.formStudy.a0814*0)!=='number'){
          this.system.map(i=>{
          if(i.DMCPT==this.formStudy.a0814){
              this.formStudy.a0814= i.DMCOD
          }
        })
        }
        if(this.formStudy.a0801 && this.formStudy.a0802){
          let data = (moment(this.formStudy.a0802, 'YYYY-MM-DD HH:mm:ss')).unix() - (moment(this.formStudy.a0801, 'YYYY-MM-DD HH:mm:ss')).unix()
          let years = Math.floor(data/(24*3600*365))
          if(years !== Number(this.formStudy.a0814)){
            this.$message.warning('您填写的学制与入学起始时间不一致，请重新填写')
            return
          }
        }
      }
      // 格式化日期的函数
       function getTargetTime(t){
        var d = t.split(" ")[0],
        h = t.split(" ")[1],
        date = new Date()

        date.setYear(d.split("-")[0])
        date.setMonth(d.split("-")[1] - 1)
        date.setDate(d.split("-")[2])

    
        return date.getTime()    
      }

      var that=this
       this.$refs.XXRef.validate(valid => {
        if(!valid) return this.$message.warning('请完成表单内容')
      //此处修改下拉框数据 为真实值
      if(!typeof(this.formStudy.a0803*0)!=='number'){
        this.educationList.map(i=>{
        if(i.DMCPT==this.formStudy.a0803){
            this.formStudy.a0803= i.DMCOD
        }
      })
      }else{
        // this.nations.a0104*0+1
      }

      if(!typeof(this.formStudy.a0804*0)!=='number'){
        this.academic.map(i=>{
        if(i.DMCPT==this.formStudy.a0804){
            this.formStudy.a0804= i.DMCOD
        }
      })
      }else{
        // this.nations.a0104*0+1
      }

      if(!typeof(this.formStudy.a0813*0)!=='number'){
        this.Education.map(i=>{
        if(i.DMCPT==this.formStudy.a0813){
            this.formStudy.a0813= i.DMCOD
        }
      })
      }else{
        // this.nations.a0104*0+1
      }

      if(!typeof(this.formStudy.a0814*0)!=='number'){
        this.system.map(i=>{
        if(i.DMCPT==this.formStudy.a0814){
            this.formStudy.a0814= i.DMCOD
        }
      })
      }else{
        // this.nations.a0104*0+1
      }

      //此处格式化时间

      if(typeof(this.formStudy.a0801)=='string'){
        if(getTargetTime(this.formStudy.a0801)>new Date().getTime()) return this.$message.warning('入学时间不能晚于当前时间');
      }else{
       if((this.formStudy.a0801).unix()*1000>new Date().getTime()) return this.$message.warning('入学时间不能晚于当前时间');
      }
      

       if(typeof(this.formStudy.a0801)=='string'&&(typeof(this.formStudy.a0802)=='string')){
         console.log(1);
         if(getTargetTime(this.formStudy.a0801)>getTargetTime(this.formStudy.a0802)) return this.$message.warning('入学时间不能晚于毕业时间');
       }else if(typeof(this.formStudy.a0801)=='string'){
         console.log(2);
         if(getTargetTime(this.formStudy.a0801)>(this.formStudy.a0802).unix()*1000) return this.$message.warning('入学时间不能晚于毕业时间');
       }else if(typeof(this.formStudy.a0802)=='string'){
         console.log(3);
         if((this.formStudy.a0801).unix()*1000>getTargetTime(this.formStudy.a0802)) return this.$message.warning('入学时间不能晚于毕业时间');
       }else{
         console.log(4);
         if((this.formStudy.a0801).unix()>(this.formStudy.a0802).unix()) return this.$message.warning('入学时间不能晚于毕业时间');
       }
       

        this.formStudy.a0801=moment(this.formStudy.a0801).format('YYYY-MM-DD');
      this.formStudy.a0802=moment(this.formStudy.a0802).format('YYYY-MM-DD');
     
      console.log(this.formStudy);
      this.post({
        url:'updateLearningExperience',
        data:this.formStudy
      },(res)=>{
        if(res.code==200){
          console.log(res);
          this.$message.success('修改学习经历成功')
          this.$emit('updt')
          that.cancel()
        }
      })
       })
    },
    
    
    //点击了取消
    cancel(){
      this.$refs.XXRef.resetFields()
      this.showVisible=false
      this.$emit('update:studyVisible',false)
      this.$emit('updt')
    },


    //下拉框数据
    // 学历
    getxl(){
      this.get({
        url:'getCodeTableAndKeyWordAllItem',
        data:{
          codeTableName:'zb64'
        }
      },(res)=>{
        if(res.code=200){
          this.educationList=res.data
        }
      })
    },
    // 学位
    getxw(){
      this.get({
        url:'getCodeTableAndKeyWordAllItem',
        data:{
          codeTableName:'GB6864'
        }
      },(res)=>{
        if(res.code=200){
          this.academic=res.data
        }
      })
    },
    // 教育类型
    getjylx(){
      this.get({
        url:'getCodeTableAndKeyWordAllItem',
        data:{
          codeTableName:'BJ011'
        }
      },(res)=>{
        if(res.code=200){
          this.Education=res.data
        }
      })
    },
    // 学制
    getxz(){
      this.get({
        url:'getCodeTableAndKeyWordAllItem',
        data:{
          codeTableName:'GKZP_DM_09'
        }
      },(res)=>{
        if(res.code=200){
          this.system=res.data
        }
      })
    },
  },
  created(){
    
  }
}
</script>





<style scoped>


.dialogFooter{
  background-color: #e3efff;
  border: 1px solid #c1d7f9;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btnStyle1{
  width: 84px;
  height: 36px;
  background-color: #f1a338;
  font-size: 16px;
  line-height: 36px;
  text-align: center;
  color: #fff;
  border: none;
  border-radius: 3px;
  margin: 10px 5px;
}

.btnStyle1:hover{
  cursor:pointer;
}






/deep/ .ant-modal-content{
  width: 696px!important;
  height: 520px!important;
}


</style>







// WEBPACK FOOTER //
// src/views/zkzw/compos/xxjl.vue